import { buildBase } from "./constants";

const BASE = buildBase("box-office");

export const BOX_OFFICE_ROUTES = (() => {
  /*
    ======================================================
    ADD ALL BASIC ROUTES HERE
    ======================================================
  */
  const basicRoutes = {
    ROOT: BASE,
    SELL: `${BASE}/sell`,
    TRANSACTIONS: `${BASE}/transactions`,
    CHECKOUT: `${BASE}/checkout`,
  };

  /*
    ======================================================
    GIFT CARDS ROUTES
    ======================================================
  */
  const GIFT_CARDS_ROOT = `${BASE}/gift-cards`;
  const GIFT_CARDS = {
    ROOT: GIFT_CARDS_ROOT,
    CREATE: `${GIFT_CARDS_ROOT}/create`,
    edit: (giftCardId: string | number) => `${GIFT_CARDS_ROOT}/${giftCardId}`,
    purchases: (giftCardId: string | number) =>
      `${GIFT_CARDS_ROOT}/${giftCardId}/purchases`,
  };

  /*
    ======================================================
    ADD ALL ROUTES THAT REQUIRE NESTING BELOW
    ======================================================
  */
  const HOLDS_ROOT = `${BASE}/holds`;
  const HOLDS = {
    ROOT: HOLDS_ROOT,
    dynamicHold: (holdId: string | number) =>
      `${HOLDS_ROOT}/dynamic-hold/${holdId}`,
    split: (basketId: string | number) => `${HOLDS_ROOT}/split/${basketId}`,
  };

  const SETTINGS_ROOT = `${BASE}/settings`;
  const SETTINGS = {
    ROOT: SETTINGS_ROOT,
    SQUARE: `${SETTINGS_ROOT}/square`,
    CHECKIN: `${SETTINGS_ROOT}/checkin`,
    REPORTS: `${SETTINGS_ROOT}/reports`,
    PRINTER: `${SETTINGS_ROOT}/printer`,
    VENUE: `${SETTINGS_ROOT}/venue`,
    LANGUAGE: `${SETTINGS_ROOT}/language`,
  };

  const GROUPS_ROOT = `${BASE}/groups`;
  const GROUPS = {
    ROOT: GROUPS_ROOT,
    detail: (groupId: string | number) => `${GROUPS_ROOT}/${groupId}`,
    team: (groupId: string | number) => `${GROUPS_ROOT}/${groupId}/team`,
    history: (groupId: string | number) => `${GROUPS_ROOT}/${groupId}/history`,
    distribute: (groupId: string | number) =>
      `${GROUPS_ROOT}/${groupId}/distribute`,
    settings: (groupId: string | number) =>
      `${GROUPS_ROOT}/${groupId}/settings`,
  };

  return {
    ...basicRoutes,
    HOLDS,
    SETTINGS,
    GROUPS,
    GIFT_CARDS,
  };
})();
